export const useEditorCanvasSurfaceHandlers = ({
  editComponent,
  dropLayer,
  allowDroplayer,
}) => {
  const handleDrop = (e) => {
    if (!editComponent) {
      dropLayer(e);
    }
  };

  const handleDragOver = (e) => {
    if (!editComponent) {
      allowDroplayer(e);
    }
  };

  return { handleDrop, handleDragOver };
};
